import './app.scss'
import { mount } from 'svelte'
import App from './App.svelte'

import * as Sentry from '@sentry/svelte'

Sentry.init({
  dsn: 'https://f1361e20d23f42458024a67df9d9a75f@o1167004.ingest.sentry.io/6257659',
  integrations: [
    Sentry.browserTracingIntegration(),
  ],
  tracesSampleRate: 0.1,
  environment: import.meta.env.NODE_ENV,
  enabled: import.meta.env.VITE_SENTRY_ENABLED === 'true',
})

const app = mount(App, {
  // @ts-ignore
  target: document.getElementById('app')
})

export default app
